import { render } from "./SurfaceGlobal.vue?vue&type=template&id=26d38082&scoped=true"
import script from "./SurfaceGlobal.vue?vue&type=script&lang=js"
export * from "./SurfaceGlobal.vue?vue&type=script&lang=js"

import "./SurfaceGlobal.vue?vue&type=style&index=0&id=26d38082&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d38082"]])

export default __exports__